// extracted by mini-css-extract-plugin
export default {"ace-c-invoice-document-upload-panel__file-name":"invoice-document-upload-panel__file-name---a9e70951"};